import type { HTMLAttributes, ReactNode } from "react";
import styles from "./Badge.module.css";
import { cx } from "./cx.js";

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: "neutral" | "positive" | "warning" | "danger" | "info";
  pill?: boolean;
  /** Adds a status dot, so the tone is not carried by colour alone. */
  dot?: boolean;
  children?: ReactNode;
}

export function Badge({
  tone = "neutral",
  pill = false,
  dot = false,
  className,
  children,
  ...rest
}: BadgeProps) {
  return (
    <span className={cx(styles.badge, styles[tone], pill && styles.pill, className)} {...rest}>
      {dot && <span className={styles.dot} aria-hidden="true" />}
      {children}
    </span>
  );
}
